<template>
  <v-container>
    <ExportarLicencias :bModalDescargas="bModalDescargas" @onClose="onClose" :oArchivos="oArchivos"/>
    <v-row class="under-sec mt-2" dense no-gutters justify="space-between">
      <v-col sm="12" md="6" lg="6" xl="6" cols="">
        <DatePicker
          :key="nForDate"
          :oattrs="{ class: 'pt-1', noGutters: true }"
          @onExportarRango="onExportarRango"
          :nMaximoDias="60"
        />
      </v-col>
      <v-col sm="12" md="2" lg="2" xl="2" cols="">
        <span class="primary--text">{{$store.state.jsIdioma.oEquivalencias.cmpCliente}} <span class="red--text">*</span></span>
        <v-select v-model="nCliente" :items="aClientes" label="Seleccione un cliente" class="mt-1" dense outlined item-text="nombreCliente" item-value="idLicencias">
        </v-select>
      </v-col>
      <v-col sm="12" md="3" lg="3" xl="3" class="text-end mt-5">
        <v-btn rounded class="mr-1" color="primary" outlined :disabled="!isValidRangoFecha" @click="onExportar">
          <v-icon>mdi-download</v-icon>
          {{$store.state.jsIdioma.oEquivalencias.btnExportar}}
        </v-btn>
        <v-btn rounded color="primary" @click="onGenerar" :loading="bLoading" :disabled="!isValidRangoFecha" >
          <v-icon left>mdi-text-box-check-outline</v-icon>
          Generar
        </v-btn>
      </v-col>
    </v-row>
    <div v-if="$store.state.token != ''" class="mt-3">
      <transition name="fade">
        <v-container v-if="items.length > 0">
          <v-row no-gutters>
            <v-col sm="12" md="5" lg="5" xl="5">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Busqueda"
                single-line
                hide-details
                outlined
                rounded
                dense
                clearable
                @click:clear="() => (search = '')"
              />
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="cmpItems"
            class="elevation-1 mt-2"
            height="65vh"
            no-data-text="No hay información para mostrar"
          />

        </v-container>
        <v-container v-else>
          <v-row justify="center" class="mb-5">
            <v-col sm="12" md="5" lg="5" xl="5">
              <div class="text-center">
                <img :src="img" alt="Empty state" width="400"/> 
                <h3 class="text-light info-text">Seleccione un rango de fechas para ver los registros.</h3>
                <h3 class="text-light info-text">El rango máximo permitido es de 2 meses.</h3>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </transition>
    </div>
  </v-container>
</template>
<script>
import DatePicker from "../../../components/Grid/components/datePicker.vue";
// import HistoricoLicencia from "@/views/Licencias/js/HistoricoLicencias.js";
import emptyState from '@/assets/img/emptyStateHistoryConection.svg';
import  axiosServices  from '@/services/axiosServices.js';
import ExportarLicencias from '@/views/Licencias/components/ExportarLicencias.vue';

export default {
  name: "GridHistorico",
  // mixins: [HistoricoLicencia],
  components: {
    ExportarLicencias,
    DatePicker,
  },
  data() {
    return {
      bDialogoFechaExportar: false,
      key: 0,
      search: "",
      sTable: "LIC_LogRegistroConexiones",
      oPropsFooter: {
        'items-per-page-text':'Registros',
        'items-per-page-options':[5, 10, 15, 50, 100]
      },
      img: emptyState,
      aClientes:[],
      nCliente:-1,
      items:[],
      headers:[
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpFechaRegistro,value:"FechaRegistro"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpHoraRegistro,value:"HoraRegistro"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpNombreUsuario,value:"NombreUsuario"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpUsuario,value:"Usuario"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpNombreCliente,value:"Cliente"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpTipoConexion,value:"TipoConexion"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpOrigen,value:"Origen"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpTipoModificacion,value:"TipoModificacion"},
        {text:this.$store.state.jsIdioma.oEquivalencias.cmpVersion,value:"Version"},
      ],
      aRangoFecha:[],
      nForDate:0,
      nPagina: 1,
      ntotal: 0,
      bLoading: false,
      options:{},
      bModalDescargas:false,
      oArchivos:{}
    };
  },
  mounted(){
    this.onObtenerClientes();
  },
  methods:{
    async onObtenerClientes(){
        try {
            const { nStatusCode, aData } = await axiosServices.getConfiguration(`licencias/obtenerClientes`, true, "")
            if (nStatusCode === 200) {          
            this.aClientes = []
            this.aClientes = aData;
            this.nKeyRefresh++;
            }
        } catch (error) {
            error
        }
    },
    onExportarRango(event) {
      this.aRangoFecha = event;
    },
    async onGenerar(){
      try {
        let sParams = `idCliente=${this.nCliente}&sFechaInicial=${this.aRangoFecha[0]}&sFechaFinal=${this.aRangoFecha[1]}`;
        const { nStatusCode, aData } = await axiosServices.getConfiguration(`licencias/obtenerHistoricoCliente`, true, sParams)
        if (nStatusCode === 200) {          
          this.items = []
          this.items = aData;
          this.nKeyRefresh++;
        }
      } catch (error) {
          error
        }
    },
    async onExportar() {
      try {
        // Limpiar archivos previos
        this.oArchivos = {};

        this.bLoadingExportar = true;

        let sParams = `idCliente=${this.nCliente}&sFechaInicial=${this.aRangoFecha[0]}&sFechaFinal=${this.aRangoFecha[1]}`;
        const { nStatusCode, aData } = await axiosServices.postConfiguration(`licencias/exportarHistoricoCliente`, {} , true, sParams)
        if (nStatusCode === 200) {
          this.oArchivos = aData;
          this.bModalDescargas = true;
        }
        this.bLoadingExportar = false;
      } catch (error) {
        this.bLoadingExportar = false;
      }
    },
    onClose() {
      this.bModalDescargas = false;
    },
  },
  computed: {
    isValidRangoFecha() {
      if (this.aRangoFecha.length !== 2 || this.nCliente==-1) return false;
      // Verificamos que ambos elementos sean diferentes de 'null' y sean fechas válidas
      return this.aRangoFecha.every((fecha) => {
        return fecha !== "null" && !isNaN(Date.parse(fecha));
      });
    },
    cmpItems() {
      if (this.search && this.search !== "") {
        return this.items.filter((item) => {
          return Object.values(item).some((val) =>
            String(val).toLowerCase().includes(this.search.toLowerCase())
          );
        });
      } else {
        return this.items;
      }
    },
  },
};
</script>
<style>
.info-text {
  color: #6b7280 !important;
}
</style>